import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from "@mui/material/Typography";
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

const MpgLoadingDialog = ({ open, actionType, sx }) => {
    /**action type could be 'create' or 'update' */

    const internalSx = {
        zIndex: 1500
    }

    const [openDialog, setOpenDialog] = useState(false)

    useEffect(() => {
        if (!!open) {
            setOpenDialog(true)
        } else {
            setOpenDialog(false)
        }
    }, [open])

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpenDialog(false);
        }
    };

    const [loaderText, setLoaderText] = useState("")
    useEffect(() => {
        if (actionType === "create") {
            setLoaderText("Creating record...")
        } else if (actionType === "update") {
            setLoaderText("Updating record...")
        } else {
            setLoaderText("Action is in progress...")
        }
    }, [actionType])

    return (
        <div>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={[internalSx, sx]}
            >
                <DialogTitle id="alert-dialog-title" sx={{ color: 'black', fontWeight: 'bold' }}>
                    Wait, working on it...!
                </DialogTitle>
                <DialogContent>

                    <Stack
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                    >

                        <CircularProgress size={30} />

                        <Typography
                            variant="body2"
                            align="center"
                        >
                            {loaderText}
                        </Typography>
                    </Stack>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        handleClose()
                    }}
                        autoFocus
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default MpgLoadingDialog